const url = "http://www.rob--lee.co.uk/apps/wp-json/";

export function getBlogInfo() {
  let data = null;

  return fetch(url, {
    method: "GET"
  })
    .then(res => {
      return res.json().then(json => {
        return (data = { name: json.name, desc: json.description });
      });
    })
    .catch(err => {
      console.log(err);
    });
}

export function getPosts(page) {
  if (!page) {
    page = 1;
  }
  return fetch(`${url}wp/v2/posts/?_embed&per_page=16&page=${page}`, {
    method: "GET"
  })
    .then(res => {
      if (res.status >= 400 && res.status < 600) {
        throw new Error("Bad response from server");
      }
      return res.json().then(json => {
        return json;
      });
    })
    .catch(err => {
      console.log(err);
    });
}

export function getPages() {
  return fetch(`${url}wp/v2/pages/`, {
    method: "GET"
  })
    .then(res => {
      return res.json().then(json => {
        return json;
      });
    })
    .catch(err => {
      console.log(err);
    });
}

export function getMedia(postID) {
  return fetch(`${url}wp/v2/media?parent=${postID}&per_page=16`, {
    method: "GET"
  })
    .then(res => {
      return res.json().then(json => {
        console.log(json);
        return json;
      });
    })
    .catch(err => {
      console.log(err);
    });
}

export function getCategory(ids) {
  return fetch(`${url}wp/v2/categories?include=${ids}&per_page=100`, {
    method: "GET"
  })
    .then(res => {
      return res.json().then(json => {
        return json;
      });
    })
    .catch(err => {
      console.log(err);
    });
}

export function getCategoryFromSlug(slug) {
  return fetch(`${url}wp/v2/categories?slug=${slug}`, {
    method: "GET"
  })
    .then(res => {
      return res.json().then(json => {
        return json[0].id;
      });
    })
    .catch(err => {
      console.log(err);
    });
}

export function getPostsByCategory(id, page) {
  if (!page) {
    page = 1;
  }
  return fetch(
    `${url}wp/v2/posts?categories=${id}&_embed&per_page=16&page=${page}`,
    {
      method: "GET"
    }
  )
    .then(res => {
      if (res.status >= 400 && res.status < 600) {
        throw new Error("Bad response from server");
      }
      return res.json().then(json => {
        return json;
      });
    })
    .catch(err => {
      console.log(err);
    });
}



// WEBPACK FOOTER //
// ./src/components/fetch/fetchApi.js